import { __assign, __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMemo, useState } from "react";
import pickBy from "lodash/pickBy";
import EditIcon from "@mui/icons-material/Edit";
import { FieldsForm, PangeaModal } from "@pangeacyber/react-mui-shared";
import { RenameUpdateFields } from "./fields";
import { useStoreFileViewerContext } from "../../hooks/context";
export var RenameAPIFields = new Set(["id", "name"]);
var RenameFileIconButton = function (_a) {
    var object = _a.object, ButtonProps = _a.ButtonProps, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b;
    var theme = useTheme();
    var _c = useStoreFileViewerContext(), apiRef = _c.apiRef, reload = _c.reload;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var handleClose = function () {
        setOpen(false);
        onClose();
    };
    var fields = useMemo(function () {
        return RenameUpdateFields;
    }, [apiRef]);
    var handleUpdate = function (body) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            if (!apiRef.update)
                return [2 /*return*/];
            setLoading(true);
            data = __assign({ id: body.id }, pickBy(body, function (v, k) { return RenameAPIFields.has(k); }));
            return [2 /*return*/, apiRef
                    .update(data)
                    .then(function () {
                    handleClose();
                    setLoading(false);
                    reload();
                })
                    .catch(function (error) {
                    setLoading(false);
                })];
        });
    }); };
    if (!object.id)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({}, ButtonProps, { onClick: function () { return setOpen(true); }, children: _jsx(EditIcon, { sx: { color: theme.palette.text.primary } }) })), _jsx(PangeaModal, { open: open, onClose: handleClose, title: "Rename", size: "small", children: _jsx(FieldsForm, { object: object, fields: fields, onSubmit: function (values) {
                        if (values.parent_id === "/") {
                            values.parent_id = "";
                        }
                        return handleUpdate(
                        // @ts-ignore
                        pickBy(values, function (v, k) { return !!v || k === "parent_id"; }));
                    }, disabled: loading }) })] }));
};
export default RenameFileIconButton;
